import * as vp from 'vopay';
import { Box, Title } from 'vopay';
import { FunctionComponent, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import GroupTable from './GroupTable/GroupTable';
import GroupContacts from './GroupContacts/ContactsContainer';
import BulkTransactionDetails from './BulkTransactionDetail';
import useFetchContactGroups from '@/hooks/useApi/useFetchContactGroups';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';
import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

type ConTactListType = {
  [key: number]: {
    Account: string;
    Amount: string;
    ClientReferenceNumber: string;
    Currency: string;
    FirstName: string;
    IsActive: string;
    LastName: string;
    Message: string;
    Token: string;
  };
};

type GroupProps = {
  type: string;
};

type FC = FunctionComponent<GroupProps>;

const GroupDetailsContainer: FC = (props: GroupProps) => {
  const { userSettings } = useUserSettingsProvider();
  const history = useHistory();
  const { type } = props;
  const [isReview, setIsReview] = useState(false);
  const [groupList, setGroupList] = useState({});
  const [isTransactionDetail, setIsTransactionDetail] = useState(false);
  const [ContactGroups, fetchContactGroups] = useFetchContactGroups({});
  const { GroupID } = useParams<{ GroupID: string }>();
  const { t } = useTranslation('translations', { keyPrefix: 'Groups.Details' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const [group, setgroup] = useState<vp.ContactGroupsLists>({
    ACTCurrencies_ID: '',
    DateAdded: '',
    Description: '',
    GroupName: '',
    ID: '',
    LastModified: '',
    Service: '',
    VIOAccounts_ID: '',
  });
  useEffect(() => {
    fetchContactGroups({
      Timezone: userSettings.timezone,
    });
  }, []);
  useEffect(() => {
    const groupSet = Object.values(ContactGroups.ContactGroups).find((contactGroup) => contactGroup.ID === GroupID);
    if (groupSet) {
      setgroup(groupSet);
    }
  }, [ContactGroups]);
  const handleReview = (e: boolean) => {
    setIsReview(e);
  };

  const handleList = (list: ConTactListType) => {
    setGroupList(list);
  };

  const handleTransactionDetail = (e: boolean) => {
    setIsTransactionDetail(e);
  };

  return (
    <>
      {isTransactionDetail ? (
        <BulkTransactionDetails groupList={groupList} type={type} />
      ) : (
        <>
          {isReview ? (
            <Box flx="col" gapSize="32px" mb="lg">
              <UtilButton
                iconLeft="chevron_left"
                size="large"
                onClick={() => {
                  setIsReview(false);
                }}
              >
                {tGlobal('Buttons.back')}
              </UtilButton>
              <Title title={t('pageTitle')} />
            </Box>
          ) : (
            <Box flx="col" gapSize="16px">
              <UtilButton
                iconLeft="chevron_left"
                size="large"
                onClick={() => {
                  if (history.length > 1) {
                    history.goBack();
                  } else {
                    const path = type === 'Payment' ? '/bulk-payment' : '/bulk-collection';
                    history.replace(path);
                  }
                }}
              >
                {history.length > 1 ? tGlobal('Buttons.back') : t('pageTitle')}
              </UtilButton>
              <Title title={t('pageTitle')} />
            </Box>
          )}
          <Box flx="col">
            <GroupTable group={group} type={type} isReview={isReview} groupList={groupList} />
            <GroupContacts
              group={group}
              groupID={GroupID}
              isReview={isReview}
              groupList={groupList}
              type={type}
              handleReview={handleReview}
              handleTransactionDetail={handleTransactionDetail}
              handleList={handleList}
            />
          </Box>
        </>
      )}
    </>
  );
};

export default GroupDetailsContainer;
